import "core-js/modules/es6.string.link";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.link";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import merge from 'lodash.merge';
export var convertLegacyTheme = function convertLegacyTheme(legacyTheme) {
  if (legacyTheme === void 0) {
    legacyTheme = {};
  }

  var _legacyTheme = legacyTheme,
      components = _legacyTheme.components,
      _legacyTheme$colors = _legacyTheme.colors,
      colors = _legacyTheme$colors === void 0 ? {} : _legacyTheme$colors,
      font = _legacyTheme.font,
      monospace = _legacyTheme.monospace,
      Provider = _legacyTheme.Provider,
      Presenter = _legacyTheme.Presenter,
      googleFont = _legacyTheme.googleFont,
      css = _legacyTheme.css,
      heading = _legacyTheme.heading,
      styles = _objectWithoutPropertiesLoose(_legacyTheme, ["components", "colors", "font", "monospace", "Provider", "Presenter", "googleFont", "css", "heading"]);

  var theme = {
    googleFont: googleFont,
    colors: _objectSpread({}, colors, {
      primary: colors.link,
      muted: colors.codeBackground
    }),
    fonts: {
      body: font,
      heading: font,
      monospace: monospace
    },
    text: {
      heading: heading
    },
    styles: merge({
      root: css,
      h1: {
        variant: 'text.heading'
      },
      h2: {
        variant: 'text.heading'
      },
      h3: {
        variant: 'text.heading'
      },
      h4: {
        variant: 'text.heading'
      },
      h5: {
        variant: 'text.heading'
      },
      h6: {
        variant: 'text.heading'
      },
      code: {
        fontFamily: 'monospace',
        color: 'code',
        bg: 'codeBackground'
      },
      pre: {
        fontFamily: 'monospace',
        color: 'code',
        bg: 'codeBackground'
      }
    }, styles)
  };
  return {
    components: components,
    theme: theme
  };
};
export default convertLegacyTheme;